import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { EquipmentExtended, EquipmentExtendedListResponse, EquipmentQueryParams } from '@frontend/equipment/types';

export class EquipmentExtendedClient extends APIClient {
    public static readonly endpoint = '/equipment-api/ext/v1';

    public static async fetchEquipmentsExtended(queryParams?: ApiQueryParams<EquipmentQueryParams>): Promise<EquipmentExtendedListResponse> {
        return await this.apiPaginated<EquipmentExtendedListResponse, EquipmentQueryParams>(`${this.endpoint}/equipments`, queryParams);
    }

    public static async fetchEquipmentExtended(accountId: string, equipmentId: string): Promise<EquipmentExtended> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/equipments/${equipmentId}`);
        return await this.handleResponse<EquipmentExtended>(response);
    }
}
